import PixagriSubscription from 'library/src/pixagriApi/subscriptions/models/PixagriSubscription';
import {
  PostSubscriptionsModel,
  SubscriptionsModel,
} from 'library/src/subscriptions/models/SubscriptionsModel';
import Subscription from '../models/Subscription';
import {SelectedSubscriptionState} from '../models/SubscriptionsState';

export const LOAD_SUBSCRIPTIONS_LISTING = 'LOAD_SUBSCRIPTIONS_LISTING';
export interface LoadSubscriptionsListingAction {
  type: typeof LOAD_SUBSCRIPTIONS_LISTING;
  payload: {
    delay?: number;
  };
}

export const LOAD_SUBSCRIPTIONS_LISTING_SUCCESS =
  'LOAD_SUBSCRIPTIONS_LISTING_SUCCESS';
export interface LoadSubscriptionsListingSuccessAction {
  type: typeof LOAD_SUBSCRIPTIONS_LISTING_SUCCESS;
  payload: {
    data: {[key: string]: Subscription} | null;
    pixagriData: {[key: string]: PixagriSubscription} | null;
  };
}

export const LOAD_INVOICES_INFO = 'LOAD_INVOICES_INFO';
export interface LoadInvoicesInfoAction {
  type: typeof LOAD_INVOICES_INFO;
  payload: string;
}

export const LOAD_INVOICES_INFO_SUCCESS = 'LOAD_INVOICES_INFO_SUCCESS';
export interface LoadInvoicesSuccessAction {
  type: typeof LOAD_INVOICES_INFO_SUCCESS;
  payload: SelectedSubscriptionState;
}

export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';
export interface GetSubscriptionsAction {
  type: typeof GET_SUBSCRIPTIONS;
}

export const GET_SUBSCRIPTIONS_SUCCESS = 'GET_SUBSCRIPTIONS_SUCCESS';
export interface GetSubscriptionsSuccessAction {
  type: typeof GET_SUBSCRIPTIONS_SUCCESS;
  payload: SubscriptionsModel[];
}

export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';
export interface CreateSubscriptionAction {
  type: typeof CREATE_SUBSCRIPTION;
  payload: PostSubscriptionsModel[];
}

export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export interface CreateSubscriptionSuccessAction {
  type: typeof CREATE_SUBSCRIPTION_SUCCESS;
}

export type SubscriptionsActionTypes =
  | LoadSubscriptionsListingAction
  | LoadSubscriptionsListingSuccessAction
  | LoadInvoicesInfoAction
  | LoadInvoicesSuccessAction
  | GetSubscriptionsAction
  | GetSubscriptionsSuccessAction
  | CreateSubscriptionAction
  | CreateSubscriptionSuccessAction;

export const subscriptionActions = {
  loadSubscriptions: (delay?: number): LoadSubscriptionsListingAction => {
    return {
      type: LOAD_SUBSCRIPTIONS_LISTING,
      payload: {
        delay: delay,
      },
    };
  },
  loadSubscriptionsSuccess: (
    subscriptions: {[key: string]: Subscription},
    pixagriSubscriptions: {[key: number]: PixagriSubscription},
  ): LoadSubscriptionsListingSuccessAction => {
    return {
      type: LOAD_SUBSCRIPTIONS_LISTING_SUCCESS,
      payload: {
        data: subscriptions,
        pixagriData: pixagriSubscriptions,
      },
    };
  },
  loadInvoicesInfo: (id: string): LoadInvoicesInfoAction => {
    return {
      type: LOAD_INVOICES_INFO,
      payload: id,
    };
  },
  loadInvoicesInfoSuccess: (
    invoices: SelectedSubscriptionState,
  ): LoadInvoicesSuccessAction => {
    return {
      type: LOAD_INVOICES_INFO_SUCCESS,
      payload: invoices,
    };
  },

  getSubscriptions: (): GetSubscriptionsAction => {
    return {
      type: GET_SUBSCRIPTIONS,
    };
  },

  getSubscriptionsSuccess: (
    subscriptions: SubscriptionsModel[],
  ): GetSubscriptionsSuccessAction => {
    return {
      type: GET_SUBSCRIPTIONS_SUCCESS,
      payload: subscriptions,
    };
  },

  createSubscription: (
    payload: PostSubscriptionsModel[],
  ): CreateSubscriptionAction => {
    return {
      type: CREATE_SUBSCRIPTION,
      payload,
    };
  },
  createSubscriptionSuccess: (): CreateSubscriptionSuccessAction => {
    return {
      type: CREATE_SUBSCRIPTION_SUCCESS,
    };
  },
};
